(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sakureva-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sp-section]').forEach((section) => {
    const gallery = section.querySelector('[data-sp-gallery]');
    if (gallery) {
      const buttons = gallery.querySelectorAll('[data-media-target]');
      const stages = gallery.querySelectorAll('[data-media-stage]');
      buttons.forEach((button) => button.addEventListener('click', () => {
        buttons.forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        stages.forEach((stage) => {
          stage.hidden = stage.dataset.mediaStage !== button.dataset.mediaTarget;
        });
      }));
    }

    const packs = section.querySelectorAll('[data-sp-pack]');
    const buyButton = section.querySelector('.sp__buy');
    const initialBuyLabel = buyButton?.textContent.trim();
    packs.forEach((pack) => pack.addEventListener('change', () => {
      if (!pack.checked) return;
      packs.forEach((item) => item.closest('.sp__pack-card').classList.toggle('is-selected', item.checked));
      const price = section.querySelector('[data-sp-current-price]');
      if (price) price.textContent = pack.dataset.price;
      const comparePrice = section.querySelector('[data-sp-compare]');
      if (comparePrice) {
        comparePrice.textContent = pack.dataset.compare || '';
        comparePrice.hidden = !pack.dataset.compare;
      }
      const purchasePrice = section.querySelector('.sp__purchase-option b');
      if (purchasePrice) purchasePrice.textContent = pack.dataset.price;
      if (buyButton) {
        const available = pack.dataset.available === 'true';
        buyButton.disabled = !available;
        buyButton.textContent = available ? (initialBuyLabel === 'Sold out' ? 'Add to bag' : initialBuyLabel) : 'Sold out';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', pack.value);
      window.history.replaceState({}, '', url);
    }));

    const quantity = section.querySelector('.sp__quantity input');
    section.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      quantity.value = Math.max(Number(quantity.min || 1), Number(quantity.value || 1) - 1);
    });
    section.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      quantity.value = Number(quantity.value || 1) + 1;
    });

    const sellingPlanInput = section.querySelector('[data-selling-plan-input]');
    section.querySelectorAll('[data-purchase-option]').forEach((option) => option.addEventListener('change', () => {
      if (!sellingPlanInput) return;
      const sellingPlanId = option.dataset.sellingPlanId || '';
      sellingPlanInput.value = sellingPlanId;
      sellingPlanInput.disabled = !sellingPlanId;
    }));
  });

  } catch(e) { console.error(e); }
})();
})();
